import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { ReactComponent as BottomArrow } from './../../../../assets/svg/bottom-arrow.svg';

const Item = ({ condition = true, profile = false, data, Login, noLink = false }) => {
  if (!condition) {
    return null;
  }

  if (profile) {
    return (
      <Link className="drawer-link-container" to={data.url}>
        <li className="drawer-link-item">
          <data.icon className="item-icon" />
          <i className=" font-20 mar-l-10" />
          {Login?.user?.first_name && Login?.user?.last_name && Login?.user?.phone_number ? (
            <span className="drawer-profile-text">
              <span>
                {Login?.user?.first_name} {Login?.user?.last_name}
              </span>
              <small>{Login?.user?.phone_number}</small>
            </span>
          ) : (
            <span className="drawer-profile-text">
              <span>حساب کاربری</span>
              <small>{Login?.user?.phone_number}</small>
            </span>
          )}
        </li>
        <BottomArrow className="drawer-left-arrow" />
      </Link>
    );
  }

  if (noLink) {
    return (
      <div className="drawer-link-container">
        <li className="drawer-link-item">
          <button className="exit-btn" onClick={() => data.onClick()} type="button">
            <data.icon className="item-icon" />
            <i className="font-20 mar-l-10" />
            <span className="text-align-right">{data.label}</span>
          </button>
        </li>
        <BottomArrow className="drawer-left-arrow" />
      </div>
    );
  }

  return (
    <Link className="drawer-link-container" to={data.url}>
      <li className="drawer-link-item">
        <data.icon className="item-icon" />
        <i className=" font-20 mar-l-10" />
        {data.label}
      </li>
      <BottomArrow className="drawer-left-arrow" />
    </Link>
  );
};

Item.propTypes = {
  condition: PropTypes.bool,
  profile: PropTypes.bool,
  data: PropTypes.object,
  noLink: PropTypes.bool
};

const mapStateToProps = (state) => ({
  Login: state.Login
});

export default connect(mapStateToProps)(Item);
